import { Link } from 'react-router-dom';
import ExposeCard from '@/components/base/ExposeCard';
import { getHotExposes, getLatestExposes, getExposeById, formatHeat } from '@/lib/content';
import { debunkedIds } from '@/mocks/exposes';
import VerdictBadge from '@/components/base/VerdictBadge';

export default function RankingSection() {
  const hot = getHotExposes(5);
  const latest = getLatestExposes(6);
  const debunked = debunkedIds
    .map((id) => getExposeById(id))
    .filter((x): x is NonNullable<ReturnType<typeof getExposeById>> => Boolean(x));

  return (
    <section className="border-y border-background-200 bg-background-100" aria-labelledby="ranking-title">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-8">
            <div className="flex items-end justify-between gap-4">
              <div>
                <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">今日热料榜</p>
                <h2 id="ranking-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  热度最高，也最容易被带节奏
                </h2>
              </div>
              <Link
                to="/ranking"
                className="hidden shrink-0 items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors sm:inline-flex whitespace-nowrap"
              >
                查看全部
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>

            <div className="mt-5 rounded-xl border border-background-200 bg-background-50 px-5 md:px-6">
              {hot.map((item, index) => (
                <ExposeCard key={item.id} item={item} layout="row" rank={index + 1} />
              ))}
            </div>

            <div className="mt-10">
              <div className="flex items-end justify-between gap-4">
                <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">最新核实记录</h3>
                <Link
                  to="/ranking"
                  className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors sm:hidden whitespace-nowrap"
                >
                  全部
                </Link>
              </div>
              <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2">
                {latest.slice(0, 4).map((item) => (
                  <ExposeCard key={item.id} item={item} />
                ))}
              </div>
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-xl border border-secondary-200 bg-secondary-50 p-5 md:p-6">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-500 text-background-50">
                  <i className="ri-shield-cross-line"></i>
                </span>
                <h3 className="font-heading text-lg font-semibold text-secondary-900">已辟谣速览</h3>
              </div>
              <p className="mt-3 text-sm text-secondary-800">
                这些料已经被证伪或给出可信回应，别再转发了。
              </p>
              <ul className="mt-4 space-y-3">
                {debunked.map((item) => (
                  <li key={item.id} className="border-t border-secondary-200 pt-3 first:border-t-0 first:pt-0">
                    <Link to={`/expose/${item.id}`} className="group block">
                      <div className="flex items-center gap-2">
                        <VerdictBadge verdict={item.verdict} showIcon={false} />
                        <span className="text-xs text-secondary-700">热度 {formatHeat(item.heat)}</span>
                      </div>
                      <p className="mt-1.5 text-sm font-medium leading-snug text-foreground-900 group-hover:text-secondary-700 transition-colors line-clamp-2">
                        {item.title}
                      </p>
                    </Link>
                  </li>
                ))}
              </ul>
              <Link
                to="/debunk"
                className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-md bg-secondary-500 px-4 py-3 text-sm font-medium text-background-50 hover:bg-secondary-600 transition-colors whitespace-nowrap"
              >
                进入辟谣专题
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>

            <div className="mt-5 rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
              <h3 className="font-heading text-base font-semibold text-foreground-950">一条料的可信度怎么看</h3>
              <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                {[
                  '有没有两个以上互相独立的来源',
                  '关键数字能否对应到可核对的口径',
                  '首发账号过往是否可靠',
                  '是否存在时间或场景上的错位',
                ].map((t) => (
                  <li key={t} className="flex items-start gap-2">
                    <span className="mt-1 w-4 h-4 flex items-center justify-center text-primary-500 shrink-0">
                      <i className="ri-checkbox-circle-line"></i>
                    </span>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}